<template>
    <div v-if="isLoading" class="loading-indicator">
        <div class="flex items-center gap-8">
            <EstravelSymbolSpinnerSVG class="spinning-logo" />
            <span class="text-sm font-medium text-primary">{{ $t('info.updating_data') }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import EstravelSymbolSpinnerSVG from '@/assets/static/icons-src/estravel-symbol-spinner.svg';

@Component({
    components: {
        EstravelSymbolSpinnerSVG
    }
})
export default class LoadingIndicator extends Vue {
    get isLoading(): boolean {
        return this.$store.getters.isUpdatingCustomerInfo;
    }
}
</script>

<style scoped>
.loading-indicator {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: white;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 999;
    animation: slideInUp 0.3s ease-out;
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
